export function getPuddleConfig() {
  var host = window.location.host;
  if (/localhost/.test(host) || /192.168/.test(host)) {
    // we are running GW locally, are we pointing at a local gaia-server?
    if (/localhost/.test(process.env.REACT_APP_SERVER_URL)) {
      // what env is the local server pointing at?
      if (/dev/.test(process.env.REACT_APP_SERVER_ENV)) {
        host = '-dev';
      } else {
        host = '-qa';
      }
    } else {
      // not pointing at localhost server, use server's url
      host = process.env.REACT_APP_SERVER_URL;
    }
  }

  if (/-qa/.test(host) || /-dev/.test(host)) {
    return {
      unencryptedPuddleUriRoot: 'https://resources-dev.dev.rosettastone.com/rs3/content/LotusAssets/data/',
      encryptedPuddleUriRoot: 'https://resources-dev.dev.rosettastone.com/rs3/content'
    };
  }

  // PROD
  return {
    unencryptedPuddleUriRoot: 'https://resources.rosettastone.com/rs3/content/LotusAssets/data/',
    encryptedPuddleUriRoot: 'https://resources.rosettastone.com/rs3/content'
  };
}